import Repository from "./Repository";

const students = "/students";

export default {
  getStudents: (params) => Repository.get(`${students}/`, { params: params }),
  getStudent: (id) => Repository.get(`${students}/${id}/`),
  updateStudent: (id, payload) =>
    Repository.patch(`${students}/${id}/`, payload),
  createStudent: (payload) => Repository.post(`${students}/`, payload),
};
